import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SeoService } from './services/seo.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  isDrawerOpened = true;
  isMobile = false;

  constructor(private router: Router, private seo: SeoService) {
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    ).subscribe(() => {
      window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
    });
    this.seo.init();
  }

  ngOnInit() {
    this.checkisMobile();
  }
 
  shouldRun = true;// = [/(^|\.)plnkr\.co$/, /(^|\.)stackblitz\.io$/].some(h => h.test(window.location.host));
  title = 'PaulAndSons';
  showFiller = false; 

  toggle()
  {
    this.isDrawerOpened = this.isDrawerOpened === true ? false : true;
  };

  checkisMobile() { 
     
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
 
    if(width < 768)
    {this.isMobile = true;
      this.isDrawerOpened = false
    }
      else
    {this.isMobile = false;}
    
    
  } 
}
